// electrospinningData.js
const initialRows = [
    {
        id: 1,
        polymerProperty: {
            polymerComponents: [],
        },
        solventProperty: {
            solventComponents: [],
        },
        solutionProperty: null,
        collectorProperty: {
            collectorType: null,
            height: null,
            heightUnit: "cm",
            width: null,
            widthUnit: "cm",
            material: null,
            rotationSpeed: null,
            rotationSpeedUnit: "rpm",
        },
        needleProperty: {},
        processParameter: {
            voltage: null,
            flowRate: null,
            tipCollectorDistance: null,
            spinningDuration: null,
            voltageUnit: 'kV',
            flowRateUnit: 'mL/h',
            tipCollectorDistanceUnit: 'cm',
            spinningDurationUnit: 'min',
            instability: [],
        },
        mechanicalProperty: {
            tensileStrength: null,
            tensileStrengthUnit: 'MPa',
            modulus: null,
            modulusUnit: 'MPa',
            elongationAtBreak: null,
            elongationAtBreakUnit: '%',
            fractureBehaviour: null,
        },
        functionalProperty: {
            surfaceArea: null,
            surfaceAreaUnit: 'm²/g',
            porosity: null,
            porosityUnit: '%',
            permeability: null,
            permeabilityUnit: 'nm²',
            wettability: null, // Contact Angle
            wettabilityUnit: '°',
            electricalConductivity: null,
            electricalConductivityUnit: 'S/m',
            thermalConductivity: null,
            thermalConductivityUnit: 'W/m·K',
        },
        applicationProperty: {
            applicationType: null,
            filtrationEfficiency: null,
            filtrationEfficiencyUnit: '%',
            drugReleaseKinetic: null,
            cellAdhesion: null,
            cellProliferation: null,
            energyStorage: null,
        },
        fiberProperty: {
            fiberDiameter: null,
            fiberDiameterUnit: "nm",
            fiberDiameterVariation: null,
            fiberDiameterVariationUnit: "nm",
            "isFormationStable": null,
            "productWeight": null,
            "productWeightUnit": "µg",
            fiberMorphology: [],
        },
        ambientParameter: {
            temperature: null,
            temperatureUnit: "°C",
            humidity: null,
            humidityUnit: "%",
        },
    },
];

export default initialRows;
